<button
  [ngClass]="customClass"
>
  <ng-container *ngIf="customIcon">
    <span class="material-icons" aria-hidden="true">{{ customIcon }}</span>
  </ng-container>
  {{ value }}
</button>
